module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("An Age of War and Tea")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_c('b', [_vm._v("About the Author")])])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_c('b', [_vm._v("Dedication")])])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_c('b', [_vm._v("Copyright Information ©")])])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_c('b', [_vm._v("Acknowledgement")])])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#map"
    }
  }, [_c('b', [_vm._v("Map")])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#list-of-characters"
    }
  }, [_c('b', [_vm._v("List of Characters")])])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#part-one"
    }
  }, [_c('b', [_vm._v("Part One")])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#prologue"
    }
  }, [_c('b', [_vm._v("Prologue")])])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#chapter-one"
    }
  }, [_vm._v("Chapter One")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#chapter-two"
    }
  }, [_vm._v("Chapter Two")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-six",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-seven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#part-two",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Two")])])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-eight",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-nine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-ten",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-eleven",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-twelve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-thirteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-fourteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-fifteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-sixteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-seventeen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#part-three",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part Three")])])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-eighteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eighteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-nineteen",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nineteen")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-twenty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-twenty-one",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-One")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-twenty-two",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Two")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-twenty-three",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Three")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-twenty-four",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Four")])]), _c('li', {
    staticStyle: {
      "margin-left": "15px"
    },
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-twenty-five",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twenty-Five")])]), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Epilogue")])])]), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#glossary",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Glossary")])])]), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Author’s Note")])])]), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#selected-biography",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Selected Biography")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0